import { CarouselManager } from "../utils/carouselManager";

class FeaturedPicksCarousel extends HTMLElement {
  constructor() {
    super();

    this.selectedCarouselIndex = 0;
  }

  async connectedCallback() {
    await this._initSliders();
    await this._fetchItems();
  }

  async _fetchItems() {
    var url = `${window.Shopify.routes.root}search?section_id=${this.dataset.sectionId}`;
    const response = await fetch(url);
    const text = await response.text();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;

    const carouselSliderEls = this.querySelectorAll(".js-carousel-slider");
    carouselSliderEls.forEach((carouselEl, index) => {
      const loaded = carouselEl.dataset.loaded === "true";
      if (!loaded) {
        const splideList = carouselEl.querySelector(".splide__list");
        const carouselSelector = `#${carouselEl.id}`;
        const newCarouselEl = tempDiv.querySelector(carouselSelector);
        const newsplideList = newCarouselEl.querySelector(".splide__list");
        splideList.innerHTML = newsplideList.innerHTML;
        if (this.carouselSliders[index]) {
          this.carouselSliders[index].refresh();
        }
        carouselEl.dataset.loaded = "true";
      }
    });
  }
  async _initSliders() {
    this._initCarouselSliders();
    this._initNavSlider();
    this._initWheels();
    this._initArrows();
    this._initButtons();
  }

  async _initNavSlider() {
    this.navSliderEl = this.querySelector(".js-nav-slider");

    this.navSlider = await CarouselManager.create(this.navSliderEl, {
      padding: 40,
      autoWidth: true,
      autoHeight: true,
      gap: 12,
      drag: "free",
      pagination: false,
      arrows: false,
      breakpoints: {
        640: {
          destroy: true,
        },
      },
    });
  }

  async _initCarouselSliders() {
    this.carouselSliderEls = this.querySelectorAll(".js-carousel-slider");

    this.carouselSliders = new Array(this.carouselSliderEls.length);
    const carouselPromises = [];
    this.carouselSliderEls.forEach((carouselSliderEl, index) => {
      carouselPromises.push(
        CarouselManager.create(carouselSliderEl, {
          padding: { left: 0, right: 40 },
          fixedWidth: 200,
          gap: 16,
          autoHeight: true,
          pagination: false,
          arrows: false,
          breakpoints: {
            640: {
              destroy: true,
            },
          },
        }).then((slider) => (this.carouselSliders[index] = slider))
      );
    });

    await Promise.all(carouselPromises);
  }

  _initWheels() {
    const collectionBlocksEl = this.querySelector(".js-collection-blocks");

    let lastTimes = [0, 0];
    collectionBlocksEl.addEventListener("wheel", (e) =>
      onWheel.call(this, e, collectionBlocksEl, this.carouselSliders[this.selectedCarouselIndex], 0)
    );

    this.navSliderEl.addEventListener("wheel", (e) => onWheel.call(this, e, this.navSliderEl, this.navSlider, 1));

    function onWheel(e, el, splide, index) {
      if(!splide || window.innerWidth < 640 || (!el.isEqualNode(e.target) && !el.contains(e.target))) return;
      const min = splide.options.wheelMinThreshold || 0;
      const sleep = splide.options.wheelSleep || 80;

      if (e.cancelable) {
        let delta = e.deltaX;

        if (e.shiftKey && delta === 0) {
          delta = e.deltaY;
        }

        const backwards = delta < 0;
        const timeStamp = Date.now();

        if (Math.abs(delta) > min && timeStamp - lastTimes[index] > sleep) {
          splide.go(backwards ? "<" : ">");
          lastTimes[index] = timeStamp;
          e.preventDefault();
        }
      }
    }
  }

  _initArrows() {
    const sliderNavEls = this.querySelectorAll(".slider-nav");
    sliderNavEls.forEach((sliderNavEl, index) => {
      const navNextBtn = sliderNavEl.querySelector(".nav-next");
      const navPrevBtn = sliderNavEl.querySelector(".nav-prev");

      const maxIndex = () => {
        const maxIndex =
          this.carouselSliders[index].Components.Controller.getEnd() - this.visibleSlides + 1;
        const currentIndex = this.carouselSliders[index].Components.Controller.getIndex();

        if (maxIndex === currentIndex) {
          return true;
        } else if (maxIndex < currentIndex) {
          this.carouselSliders[index].Components.Controller.setIndex(maxIndex);
          return true;
        } else {
          return false;
        }
      };

      navNextBtn.addEventListener("click", () => {
        if (maxIndex() || !this.carouselSliders[index]) return;
        this.carouselSliders[index].go(">");
      });

      navPrevBtn.addEventListener("click", () => {
        if (!this.carouselSliders[index]) return;
        maxIndex();
        this.carouselSliders[index].go("<");
      });
    });
  }

  _initButtons() {
    const collectionBlocks = this.querySelectorAll(".collection-block");
    const btns = this.querySelectorAll("button.js-change-carousel");

    btns.forEach((btn) =>
      btn.addEventListener("click", () => {
        const carouselIndex = parseInt(btn.dataset.index);
        collectionBlocks[this.selectedCarouselIndex].setAttribute("aria-hidden", true);
        collectionBlocks[carouselIndex].setAttribute("aria-hidden", false);
        btns[this.selectedCarouselIndex].setAttribute("aria-checked", false);
        btns[carouselIndex].setAttribute("aria-checked", true);
        this.selectedCarouselIndex = carouselIndex;
      })
    );
  }

  get visibleSlides() {
    if (!this.carouselSliders[this.selectedCarouselIndex]) return 1;
    if (!this._visibleSlides || this._windowWidth !== window.innerWidth) {
      this._windowWidth = window.innerWidth;
      this._visibleSlides = this.carouselSliders[this.selectedCarouselIndex].root.querySelectorAll(
        ".splide__slide.is-visible"
      ).length;
    }
    return this._visibleSlides;
  }
}

if (!customElements.get("featured-picks-carousel")) {
  customElements.define("featured-picks-carousel", FeaturedPicksCarousel);
}
